// What the SOA statement uploader accepts. Mirrors the BE statement-upload
// contract: PDF/XLS/XLSX plus JPEG/PNG/WebP photos of paper statements (≤10MB each).
//
// The list handed to `FileUploader` has to be MIME-type-first, because the component
// validates with `acceptedTypes.includes(file.type)` — and `File.type` is always a MIME
// type. An extension-only list therefore rejects *every* file ("The following files have
// an invalid type: …") and `onUpload` never fires. The extensions below are additive:
// they only widen the browse dialog's `accept` attribute, which the component builds by
// joining this same list.

/** Drives validation — must match `File.type` exactly. */
export const STATEMENT_MIME_TYPES = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

/** Only widens the browse dialog's filter; never matches `File.type`. */
export const STATEMENT_FILE_EXTENSIONS = ['.pdf', '.xls', '.xlsx', '.jpg', '.jpeg', '.png', '.webp'] as const;

/**
 * `File.type` is derived from an OS-level mapping, so a machine without Office
 * installed hands back an empty string for .xls/.xlsx. Accepting that empty type keeps
 * those uploads working — the browse dialog still filters by the extensions above, and
 * the BE re-validates the real content type on upload.
 */
export const UNKNOWN_MIME_TYPE = '';

export const STATEMENT_ACCEPT_TYPES: string[] = [
  ...STATEMENT_MIME_TYPES,
  ...STATEMENT_FILE_EXTENSIONS,
  UNKNOWN_MIME_TYPE,
];
